import { type yup } from '@framework/validation/initYup.ts';
import { useMemo } from 'react';
import { procedureGetQueryParamsSchema } from '../validators/procedureGetQueryParamsSchema.ts';

/**
 * Genera dinamicamente lo schema di validazione dei searchable in base ai valori
 * statici (campi sempre presenti) e quelli dinamici (e.g. tag semantici recuperati
 * da API).
 */
export function useProcedureSearchableSchema(input: {
  extraShape?: Record<string, yup.AnySchema>;
}) {
  const { extraShape } = input;

  const schema = useMemo(() => {
    return procedureGetQueryParamsSchema.shape(extraShape ?? {});
  }, [extraShape]);

  return schema;
}
